module.exports = __webpack_public_path__ + "static/media/flyerMMS.93a9a993.jpg";